import React, { useEffect, useRef, useState } from 'react'
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { Loader, Modal } from 'rsuite';
import { BsCheckSquare, BsFillTelephoneOutboundFill, BsXSquare } from 'react-icons/bs'
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { useDispatch } from 'react-redux';
import { checkEmployerIdNumberExists, checkExistingMastersByName, getMasterSupplierDetailsById } from '../../redux/actions/vendor';
import { toast } from '../CommonComponents/ToastComponent/toast';
import { MdOutlineChangeCircle } from 'react-icons/md';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { RiFileCopyLine } from 'react-icons/ri';
import SupplyComponent from '../AssignVendorComponent/tabs/SupplyComponent';
import LoaderComponent from '../CommonComponents/LoaderComponent';
import { parseFullAddress } from '../../redux/actions/upload';
import { getParsedAddress } from '../../services/helper';
import ContactView from '../ContactsComponent/contactView';
import AllContacts from '../ContactsComponent/allContacts';
import { getExistingContacts } from '../../redux/actions/contact';
import ModalComponent from '../CommonComponents/Modal';
import CreateContact from '../ContactsComponent/createContact';

const SupplierBasicInfo = ({ listSupplierInfo, basicInfo, columns, onChangeBasicInfo, isPhoneValid, isValidatingPhone, handleBasicInfoPhoneNumberFocusOut, handleBasicInfoEmailFocusOut, isEmailValid, isValidatingEmail, countryCode, onSave, onCancel, onCopyClick, supNameForEIN, isLoadingInfo = false, isDisabledButtons = false, onPhoneClick, setBasicInfo, onAssignMaster = () => { }, setAllContacts, allContacts = [], listSupplierId = null, vendorInCallsDetailsId = null, onGetAllContactsData, newMasterGenericFeeValues = {}, newMasterSupplierBasicInfo = {}, activeKey, matchedSupplierId }) => {

    const dispatch = useDispatch()
    const [einSupplier, setEinSupplier] = useState({});
    const [isLoading, setIsLoading] = useState(false)
    const [existingMasters, setExistingMasters] = useState([])
    const [masterSupplierData, setMasterSupplierData] = useState({})
    const [isLoadingExistingMasters, setIsLoadingExistingMasters] = useState(false)
    const [showExistingMasters, setShowExistingMasters] = useState(false)
    const [showMasterDetailsModal, setShowMasterDetailsModal] = useState(false)
    const [qaStatus, setQaStatus] = useState('')
    const [isLoadingExistingMasterDetail, setILoadingExistingMasterDetail] = useState(false)
    const [isParsingAddress, setIsParsingAddress] = useState(false)
    const [showAllContacts, setShowAllContacts] = useState({
        email: false,
        phone: false
    })
    const [existedContacts, setExistedContacts] = useState([])
    const [isLoadingExistingContacts, setIsLoadingExistingContacts] = useState(false)
    const [currentContact, setCurrentContact] = useState({})
    const [showAddNewContact, setShowAddNewContact] = useState(false)
    const [contactDataFromField, setContactDataFromField] = useState({})

    const handleChange = async (
        columnName,
        newValue,
        country,
        event
    ) => {
        if (columnName === 'phone') {
            onChangeBasicInfo(columnName, newValue, country, event)
        } else {
            onChangeBasicInfo(columnName, newValue)
        }
        if (columnName === 'employerIdNumber') {
            setEinSupplier({})
        }
    }

    const phoneInputRefname = useRef(null);

    const handlePhoneNumberFocusOut = async (event, country, phoneValue) => {
        handleBasicInfoPhoneNumberFocusOut(event, country, phoneValue)
    }

    const handleKeyDown = (e, phoneInputRefname) => {
        if (e.keyCode === 9) {
            phoneInputRefname.current.props.onBlur()
        }
    }

    const handleEmailFocusOut = async (emailValue, isRetry = false) => {
        handleBasicInfoEmailFocusOut(emailValue, isRetry)
    }

    const checkIfEinExist = async (e) => {
        if (e.target.value !== '' && !/^(\d{2}-\d{7})?$/.test(e.target.value)) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Employee Id Number. Must be 9 digit number formatted xx-xxxxxxx.'
            })
            return
        }
        setIsLoading(true)
        await dispatch(checkEmployerIdNumberExists({
            employerIdNumber: e.target.value,
            getEINData: true
        })).then((result) => {
            setIsLoading(false)
            if (result?.einResult[0]?.id) {
                setEinSupplier(result?.einResult[0])
            } else {
                setEinSupplier({})
            }
        }).catch((err) => {
            setIsLoading(false)
            setEinSupplier({})

        })
    }

    useEffect(() => {
        setEinSupplier(supNameForEIN)
    }, [])


    useEffect(() => {
        if (basicInfo) {
            if (
                !basicInfo.abbreviatedState?.label &&
                !basicInfo.abbreviatedState?.value
            ) {
                basicInfo.abbreviatedState = {
                    label: basicInfo.state?.label,
                    value: basicInfo.state?.value,
                };
            }
        }
    }, [basicInfo]);

    const showEINIfExist = Object.keys(einSupplier).length !== 0 ? (
        <div className="d-flex align-items-center gap-2 offset-6 col-6 mt-4">
            <h4 className='w-25 first-child fw-bold text-black mb-0'>EIN exist for this supplier </h4>
            <Link className='fs-4' target='_blank' to={`/suppliers/${einSupplier?.id}`}>{einSupplier?.suppliername}</Link>
        </div>
    ) : null

    const onCopyHandler = (value, col) => {
        if (value === "") {
            return;
        }

        setBasicInfo(prevState => {
            return {
                ...prevState,
                [col.name]: { label: value, value: value }
            }
        })
    }

    useEffect(() => {
        if (basicInfo?.suppliername?.value && basicInfo?.suppliername?.value?.length >= 2) {
            setIsLoadingExistingMasters(true)
            const delayDebounceFn = setTimeout(async () => {
                try {
                    onSupplierNameChange([basicInfo?.suppliername?.value])
                } catch (err) {
                    setExistingMasters([])
                }
            }, 1000)

            return () => clearTimeout(delayDebounceFn)
        }
    }, [basicInfo?.suppliername?.value])

    const onSupplierNameChange = async (supplierNames = []) => {
        if (supplierNames && supplierNames?.length > 0) {
            await dispatch(
                checkExistingMastersByName(supplierNames)
            ).then(masters => {
                if (masters && masters?.length > 0) {
                    setShowExistingMasters(true)
                    setExistingMasters(masters)
                } else {
                    setExistingMasters([])
                }
                setIsLoadingExistingMasters(false)
                return masters
            }).catch(() => {
                setExistingMasters([])
                setShowExistingMasters(false)
                setIsLoadingExistingMasters(false)
            })
        }
    }

    const handleMasterNameClick = async (masterId = null) => {
        if (masterId) {
            setILoadingExistingMasterDetail(true)
            dispatch(
                await getMasterSupplierDetailsById(masterId)
            ).then((masterData) => {
                let qaStatus = (masterData?.supplierInfo?.isInCalls || masterData?.detailInfo?.approvedByQA === 9) ? 'In Calls' : masterData?.detailInfo?.approvedByQA === 8 ? 'Approved' : masterData?.detailInfo?.approvedByQA === 7 ? 'Rejected' : 'Pending'
                const masterDetails = masterData?.supplierInfo || {}
                masterDetails.payment = masterData?.paymentInfo || {}
                masterDetails.cardAcceptance = masterData?.cardInfo || {}
                masterDetails.cardEmailsInfo = masterData?.cardEmailsInfo || {}
                setMasterSupplierData(masterDetails)
                setQaStatus(qaStatus)
                setShowMasterDetailsModal(true)
                setILoadingExistingMasterDetail(false)
            }).catch(() => {
                setMasterSupplierData({})
                setShowMasterDetailsModal(false)
                setILoadingExistingMasterDetail(false)
            })
        }
    }

    const onClose = () => {
        setMasterSupplierData({})
        setShowMasterDetailsModal(false)
    }

    const handleConfirmClick = (masterId) => {
        onAssignMaster(masterId)
        setExistingMasters([])
        setShowExistingMasters(false)
        onClose()
    }

    const parseAddress = async () => {
        if (basicInfo?.address1?.value) {
            try {
                setIsParsingAddress(true)
                const addressResult = await dispatch(parseFullAddress(basicInfo?.address1?.value))
                setIsParsingAddress(false)
                const parsedResult = getParsedAddress(addressResult)
                onChangeBasicInfo('parseAddress', parsedResult)
            } catch (err) {
                setIsParsingAddress(false)
            }
        }
    }

    const onContactMouseHover = (event) => {
        const parentWithClass = event.target.closest('.phone-input-parent')
        if (event.target?.dataset?.contactId) {
            const contact = allContacts?.find(data => data?.id === parseInt(event.target?.dataset?.contactId))
            setCurrentContact(contact ? contact : {})
        } else {
            setCurrentContact({})
        }
        if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
            parentWithClass.nextSibling.style.display = 'block'
        } else if (event.target && event.target?.nextSibling && event.target?.nextSibling?.classList?.value?.includes('contact-view')) {
            event.target.nextSibling.style.display = 'block'
        }
    }

    const onContactMouseHoverOut = (event) => {
        const parentWithClass = event.target.closest('.phone-input-parent')
        if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
            parentWithClass.nextSibling.style.display = 'none'
        } else if (event.target && event.target?.nextSibling && event.target?.nextSibling.classList?.value?.includes('contact-view')) {
            event.target.nextSibling.style.display = 'none'
        }
        setCurrentContact({})
    }

    const onPhoneEmailClick = (type1, type2) => {
        setShowAllContacts({ ...showAllContacts, [type1]: !showAllContacts?.[type1], [type2]: false })
        setExistedContacts(allContacts)
    }

    const onPhoneEmailFocusOutClick = () => {
        setShowAllContacts({ ...showAllContacts, email: false, phone: false })
        setExistedContacts(allContacts)
    }

    useEffect(() => {
        if (showAllContacts?.phone && basicInfo?.phone?.value?.trim() && basicInfo?.phone?.value?.trim()?.length >= 4) {
            setIsLoadingExistingContacts(true)
            const delayDebounceFn = setTimeout(async () => {
                onGetExistingContacts(basicInfo?.phone?.value?.trim(), 'phone')
            }, 1000)

            return () => clearTimeout(delayDebounceFn)
        } else {
            setIsLoadingExistingContacts(false)
        }
    }, [basicInfo?.phone?.value])

    useEffect(() => {
        if (showAllContacts?.email && basicInfo?.email?.value?.trim() && basicInfo?.email?.value?.trim()?.length >= 4) {
            setIsLoadingExistingContacts(true)
            const delayDebounceFn = setTimeout(async () => {
                onGetExistingContacts(basicInfo?.email?.value?.trim(), 'email')
            }, 1000)

            return () => clearTimeout(delayDebounceFn)
        } else {
            setIsLoadingExistingContacts(false)
        }
    }, [basicInfo?.email?.value])

    const onGetExistingContacts = (searchValue, type = '') => {
        try {
            setIsLoadingExistingContacts(true)
            dispatch(getExistingContacts({ searchValue, type })).then((res) => {
                if (res?.contacts && res?.contacts?.length > 0) {
                    if (basicInfo?.id) {
                        res?.contacts.sort((a, b) => {
                            const aContains = a?.supplierIds.includes(basicInfo?.id) ? 1 : 0;
                            const bContains = b?.supplierIds.includes(basicInfo?.id) ? 1 : 0;
                            return bContains - aContains;
                        })
                    }
                    setExistedContacts(res?.contacts)
                } else {
                    setExistedContacts([])
                }
                setIsLoadingExistingContacts(false)
            }).catch(() => {
                setExistedContacts([])
                setIsLoadingExistingContacts(false)
            })
        } catch (err) {
            setExistedContacts([])
            setIsLoadingExistingContacts(false)
        }
    }

    const handleContactClick = async (rowData) => {
        var colName = ''
        var value = {
            target: {}
        }
        if (showAllContacts?.phone) {
            if (!rowData?.phone) {
                toast.show({
                    title: 'Warning',
                    description: 'No phone number is assigned to this contact!'
                })
                return
            }
            colName = 'phone'
            value.target.value = rowData?.phone || ''
            value.target.phoneContactId = rowData?.id || null
            handlePhoneNumberFocusOut(null, null, value.target.value)
        }
        if (showAllContacts?.email) {
            if (!rowData?.email) {
                toast.show({
                    title: 'Warning',
                    description: 'No email is assigned to this contact!'
                })
                return
            }
            colName = 'email'
            value.target.value = rowData?.email || ''
            value.target.emailContactId = rowData?.id || null
            handleEmailFocusOut(value.target.value)
        }
        if (rowData) {
            const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
            const index = tmpContacts?.findIndex(data => data?.id === rowData?.id)
            if (index === -1) {
                tmpContacts.push(rowData)
            }
            setAllContacts(tmpContacts)
        }
        handleChange(colName, value)
        onPhoneEmailFocusOutClick()
    }

    const onCreateContact = () => {
        let value = ''
        let colName = ''
        if (showAllContacts?.phone) {
            colName = 'phone'
            value = basicInfo?.phone?.value ? (!/^\s*(?:\+?(\d{1,3})\s)/.test(basicInfo?.phone?.value) ? `1 ${basicInfo?.phone?.value}` : basicInfo?.phone?.value) : ''
        } else {
            colName = 'email'
            value = basicInfo?.email?.value || ''
        }
        setShowAddNewContact(true)
        setContactDataFromField({
            colName,
            value
        })
        onPhoneEmailFocusOutClick()
    }

    const handleCreateContactClose = async (e, isGetContactsData = false, contact = null) => {
        if (isGetContactsData) {
            onGetAllContactsData()
        }
        const contactId = contact?.id || null
        if (contactId) {
            contact.contactName = contact?.firstname + ' ' + contact?.lastname
            const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
            tmpContacts.push(contact)
            if (contactDataFromField?.colName === 'email') {
                var value = {
                    target: {}
                }
                value.target.value = contact?.email || ''
                value.target.emailContactId = contactId
                handleChange('email', value)
                await handleEmailFocusOut(value.target.value)
            } else {
                var value = {
                    target: {}
                }
                value.target.value = contact?.phone || ''
                value.target.phoneContactId = contactId
                handleChange('phone', value)
                await handlePhoneNumberFocusOut(null, null, value.target.value)
            }
            setAllContacts(tmpContacts)
            setExistedContacts(tmpContacts)
            onSave(contactId, contactDataFromField?.colName, tmpContacts);
        }

        setContactDataFromField({})
        setShowAddNewContact(false)
    }

    const onGetContactsData = () => {
        if (showAllContacts?.email) {
            onGetExistingContacts(basicInfo?.email?.value?.trim(), 'email')
        }
        if (showAllContacts?.phone) {
            onGetExistingContacts(basicInfo?.phone?.value?.trim(), 'phone')
        }
    }

    const handleRemoveContact = (colName) => {
        var value = {
            target: {}
        }
        if (colName === 'email') {
            value.target.value = ''
            value.target.emailContactId = null
            handleChange(colName, value)
        } else {
            value.target.value = ''
            value.target.phoneContactId = null
            handleChange(colName, value)
        }
    }

    return (
        <div className="card m-0 content">
            <div className="card-header flex-column flex-sm-row align-items-start align-items-sm-center pt-2 pb-2 h-auto bg-white position-sticky top-0 sticky-header">
                <div className='add-caller-details-header d-flex w-100'>
                    <h3 className='first-child fw-bold'>Uploaded Supplier Info</h3>
                    <div className='empty-column'></div>
                    <div className='d-flex align-items-center'>
                        <h3 className='fw-bold'>Confirm Master Supplier Info</h3>
                        <div className="ms-auto tool d-flex gap-3">
                            <button
                                type="button"
                                className="card-edit-button me-0 ps-3 pe-3 ps-sm-4 pe-sm-4 width-100"
                                onClick={() => { onCancel('basic') }}
                            >
                                Cancel
                            </button>
                            {isValidatingPhone || isValidatingEmail ? (
                                <button
                                    type="button"
                                    className="card-edit-button me-0 ps-3 pe-3 ps-sm-4 pe-sm-4"
                                >
                                    Validating...
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="card-edit-button ps-3 pe-3 ps-sm-4 pe-sm-4 width-100"
                                    onClick={onSave}
                                    disabled={isLoadingInfo || isDisabledButtons}
                                >
                                    {Object.keys(newMasterSupplierBasicInfo?.baseInfo || {})?.length > 0 ? "Save" : "Create"}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className='basic-tab'>
                <div className="card-content ps-5 pe-5 border-0 list main-info">
                    <button className='ms-auto fs-4 px-4 mt-3 p-3 py-2 rounded mb-0 btn-green' onClick={onCopyClick}> Copy Info</button>
                    {
                        columns && columns.length > 0 && columns.map(col => {
                            if (col.name === 'url' || col.name === 'naics' || col.name === 'sic' || col.name === 'state' || col.name === 'employerIdNumber') {
                                return
                            }
                            return (
                                <div key={col.name} className='main-info-child flex align-items-center'>
                                    <h4 className='first-child fw-bold text-black mb-0'>{col.label}:</h4>
                                    {col.name === 'phone' ?
                                        <>
                                            <div className="phone-input-parent flex align-center">
                                                <div className='d-flex border rounded phone-input-ext-container w-100 flex-column flex-lg-row'>
                                                    <ReactPhoneInput
                                                        className='phone-input-parent'
                                                        country={'us'}
                                                        value={listSupplierInfo?.[col.name]?.value || ''}
                                                        disabled={true}
                                                        buttonClass='border-0 border-end'
                                                        inputProps={{
                                                            className: 'form-control border-0'
                                                        }}
                                                    />
                                                    <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                                        <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                                        <input type="text" className="shadow-none w-100 border-0 ps-3 pe-3 h4 mb-0 text-dark" placeholder="phone extension" disabled={true} />
                                                    </div>
                                                    <CopyToClipboard text={listSupplierInfo?.[col.name]?.value || ''}>
                                                        <button className='input-group-text' onClick={() => { onCopyHandler(listSupplierInfo?.[col.name]?.value, col) }}><RiFileCopyLine size={26} color="rgb(87 171 234)" /></button>
                                                    </CopyToClipboard>
                                                </div>
                                            </div>
                                            <div className="phone-input-parent flex align-center">
                                                <div className={`d-flex border rounded phone-input-ext-container w-100 flex-column flex-lg-row position-relative${basicInfo?.phoneContactId?.value ? ' input-group' : ''}`}>
                                                    {basicInfo?.phoneContactId?.value && (
                                                        <span role='button' class='border border-start-0 border-top-0 border-bottom-0 input-group-text text-red px-3 fs-2 fw-bold mb-0' onClick={() => { handleRemoveContact('phone') }}>X</span>
                                                    )}
                                                    <input
                                                        value={basicInfo[col.name]?.value || ''}
                                                        className={`search-input basicvalue border-0 h4 mb-0 text-primary ms-0`}
                                                        onChange={e => handleChange(col.name, e)}
                                                        autoComplete='no-phone'
                                                        onClick={() => { onPhoneEmailClick('phone', 'email') }}
                                                        onMouseOver={(e) => { onContactMouseHover(e) }}
                                                        onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                                        data-contact-id={basicInfo?.phoneContactId?.value || ''}
                                                    // onBlur={(event) => { isPhoneValid === '' && handlePhoneNumberFocusOut(event, null, supplierInfo[col.name]) }}
                                                    />
                                                    {basicInfo?.[col.name]?.value && !showAllContacts?.phone && (
                                                        <ContactView contact={currentContact} />
                                                    )}
                                                    {showAllContacts?.phone && (
                                                        <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={onCreateContact} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} supplierId={basicInfo?.id || null} />
                                                    )}
                                                    <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                                        <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                                        <input
                                                            type="text"
                                                            className="shadow-none w-100 border-0 ps-3 pe-3 h4 mb-0 text-dark"
                                                            placeholder="phone extension"
                                                            onChange={(newValue) => handleChange('phoneExtension', newValue)}
                                                            value={basicInfo?.['phoneExtension']?.value || ''}
                                                            disabled={(!basicInfo?.['phone']?.value || !isPhoneValid || basicInfo?.['phone']?.value === countryCode) ? true : false}
                                                        />

                                                    </div>
                                                </div>
                                                {isValidatingPhone && (<Loader />)}
                                                {!isValidatingPhone && isPhoneValid !== '' &&
                                                    (isPhoneValid ?
                                                        <BsCheckSquare color="#067911" size={22} />
                                                        :
                                                        <BsXSquare color="#f75a52" size={22} />
                                                    )
                                                }
                                                {isPhoneValid && basicInfo?.[col.name]?.value && (
                                                    <BsFillTelephoneOutboundFill role='button' color="#104569" size={22} onClick={() => { onPhoneClick(basicInfo?.[col.name]?.value) }} />
                                                )}
                                            </div>
                                        </>
                                        :
                                        col.name === 'email' ?
                                            <>
                                                <div className="input-group h-100">
                                                    <input
                                                        type="text"
                                                        className="search-input fs-4 mb-0 form-control"
                                                        value={listSupplierInfo?.[col.name]?.value || ''}
                                                        disabled={true}
                                                    />
                                                    <CopyToClipboard text={listSupplierInfo?.[col.name]?.value || ''}>
                                                        <button className='input-group-text' onClick={() => { onCopyHandler(listSupplierInfo?.[col.name]?.value, col) }}>
                                                            <RiFileCopyLine size={26} color="rgb(87 171 234)" />
                                                        </button>
                                                    </CopyToClipboard>
                                                </div>
                                                <div className={`phone-input-parent flex align-center position-relative${basicInfo?.emailContactId?.value ? ' input-group h-100 align-items-center' : ''}`}>
                                                    {basicInfo?.emailContactId?.value && (
                                                        <span role='button' class='border-end-0 input-group-text text-red px-3 fs-2 fw-bold h-100 mb-0' onClick={() => { handleRemoveContact('email') }}>X</span>
                                                    )}
                                                    <input
                                                        type="text"
                                                        style={{ marginLeft: basicInfo?.emailContactId?.value ? '-10px' : '0' }}
                                                        className="search-input h4 mb-0 text-primary"
                                                        onChange={(newValue) => handleChange(col.name, newValue)}
                                                        value={basicInfo?.[col.name]?.value || ''}
                                                        // onBlur={() => { handleEmailFocusOut(basicInfo?.[col.name]?.value) }}
                                                        onClick={() => { onPhoneEmailClick('email', 'phone') }}
                                                        onMouseOver={(e) => { onContactMouseHover(e) }}
                                                        onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                                        data-contact-id={basicInfo?.emailContactId?.value || ''}
                                                        autoComplete='no-email'
                                                    />
                                                    {basicInfo[col.name]?.value && !showAllContacts?.email && (
                                                        <ContactView contact={currentContact} />
                                                    )}
                                                    {showAllContacts?.email && (
                                                        <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={onCreateContact} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} supplierId={basicInfo?.id || null} />
                                                    )}
                                                    {isValidatingEmail && (<Loader />)}
                                                    {basicInfo?.[col.name]?.value && !isValidatingEmail && isEmailValid !== '' &&
                                                        (isEmailValid ?
                                                            <BsCheckSquare color="#067911" size={26} />
                                                            :
                                                            <>
                                                                <BsXSquare color="#f75a52" size={26} />
                                                                {/* <MdOutlineChangeCircle
                                                                    title='Retry'
                                                                    role='button'
                                                                    color="#14438b"
                                                                    size={30}
                                                                    onClick={() => { handleEmailFocusOut(basicInfo?.[col.name]?.value, true) }}
                                                                /> */}
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </>
                                            :
                                            <>
                                                <div class="input-group h-100 ">
                                                    {/* <div class="d-flex h-100 w-100"> */}
                                                    <input
                                                        type="text"
                                                        className=" search-input fs-4 mb-0 form-control"
                                                        value={listSupplierInfo?.[col.name]?.value || ''}
                                                        disabled={true}
                                                    />
                                                    <CopyToClipboard text={listSupplierInfo?.[col.name]?.value || ''}>
                                                        <button
                                                            className='input-group-text'
                                                            onClick={() => { onCopyHandler(listSupplierInfo?.[col.name]?.value, col) }}
                                                        >
                                                            <RiFileCopyLine size={26} color="rgb(87 171 234)" />
                                                        </button>
                                                    </CopyToClipboard>
                                                    {/* </div> */}
                                                </div>
                                                <div className="phone-input-parent flex align-center">
                                                    <div className={`position-relative w-100${isLoadingExistingMasterDetail ? ' loading' : ''}${col.name === 'address1' ? ' d-flex gap-3 h-100' : ''}`}>
                                                        <input
                                                            type="text"
                                                            className="search-input h4 mb-0"
                                                            onChange={(newValue) => handleChange(col.name, newValue)}
                                                            value={basicInfo?.[col.name]?.value || ''}
                                                        />
                                                        {col.name === 'address1' && basicInfo?.address1?.value && (
                                                            <div className="position-relative text-center">
                                                                {isParsingAddress && <Loader size="sm" className="top-33 position-absolute start-0 end-0" />}
                                                                <button
                                                                    type="button"
                                                                    className={`${isParsingAddress ? 'bg-light ' : ''}h-100 ps-3 pe-3 ps-sm-4 pe-sm-4 width-100 bg-dark-blue rounded text-white`}
                                                                    onClick={parseAddress}
                                                                >
                                                                    Parse Address
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                    }
                                </div>
                            )
                        })
                    }
                </div>
                <div className="card-content ps-4 pe-4 m-5 rounded border border-1">
                    <div className="row">
                        <div className="d-flex align-items-center gap-2 col-6">
                            <h4 className='w-25 first-child fw-bold text-black mb-0'>SIC Code:</h4>
                            <input
                                type="text"
                                className="search-input h4 mb-0 w-50"
                                onChange={(newValue) => handleChange('sic', newValue)}
                                value={basicInfo?.['sic']?.value}
                            />
                        </div>
                        <div className="d-flex align-items-center gap-2 col-6">
                            <h4 className='w-25 first-child fw-bold text-black mb-0'>URL:</h4>
                            <input
                                type="text"
                                className="search-input h4 mb-0 w-50"
                                onChange={(newValue) => handleChange('url', newValue)}
                                value={basicInfo?.['url']?.value}
                            />
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="d-flex align-items-center gap-2 col-6">
                            <h4 className='w-25 first-child fw-bold text-black mb-0'>NAICS Code:</h4>
                            <input
                                type="text"
                                className="search-input h4 mb-0 w-50"
                                onChange={(newValue) => handleChange('naics', newValue)}
                                value={basicInfo?.['naics']?.value}
                            />
                        </div>
                        <div className="d-flex align-items-center gap-2 col-6">
                            <h4 className='w-25 first-child fw-bold text-black mb-0'>Employer Id Number:</h4>
                            <input
                                type="text"
                                className="search-input h4 mb-0 w-50"
                                onChange={(newValue) => handleChange('employerIdNumber', newValue)}
                                value={basicInfo?.['employerIdNumber']?.value}
                                onBlur={checkIfEinExist}
                            />
                            {isLoading ? <Loader /> : null}
                        </div>
                        {showEINIfExist}
                    </div>
                </div>
            </div>
            {showMasterDetailsModal && (
                <Modal
                    backdrop='static'
                    className="merge-master-modal supplier-info-modal px-5"
                    show={showMasterDetailsModal}
                    size="xl"
                    onClick={() => { onClose() }}
                    onHide={() => { onClose() }}
                >
                    <Modal.Header>
                    </Modal.Header>
                    <Modal.Body className='pb-0'>
                        <SupplyComponent
                            masterSupplierId={masterSupplierData?.id}
                            qaStatus={qaStatus}
                            isFromExistingMaster={true}
                            onConfirmClick={handleConfirmClick}
                        />
                    </Modal.Body>
                </Modal>
            )}
            {showAddNewContact && (
                <>
                    <ModalComponent size='xl' modalTitle='' open={showAddNewContact} handleClose={handleCreateContactClose} dialogClassName='px-5 create-new-contact-modal-dialog'>
                        <CreateContact
                            onClose={handleCreateContactClose}
                            contactDataFromField={contactDataFromField}
                            supplierId={matchedSupplierId || activeKey === 'reenablement' ? matchedSupplierId : basicInfo?.id || null}
                            listSupplierId={matchedSupplierId || activeKey === 'reenablement' ? basicInfo?.id : basicInfo?.id ? null : listSupplierId}
                            isInCalls={matchedSupplierId || activeKey === 'reenablement' ? true : basicInfo?.id ? null : true}
                            vendorInCallsDetailsId={basicInfo?.id ? null : (vendorInCallsDetailsId || null)}
                        />
                    </ModalComponent>
                </>
            )}
        </div>
    )
}

export default SupplierBasicInfo